import { memo, useCallback } from "react";
import { SunIcon, MoonIcon } from "@/components/icons/AppIcons";
import { useThemeStore } from "@/stores/theme";
import IconButton from "@/components/common/GoogleIconButton";

export const ThemeToggle = memo(function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  const toggle = useCallback(() => {
    setTheme(theme === "light" ? "dark" : "light");
  }, [theme, setTheme]);

  return (
    <IconButton
      type="button"
      onClick={toggle}
      aria-label={
        theme === "light" ? "Switch to dark mode" : "Switch to light mode"
      }
      sx={{
        width: 44,
        height: 44,
        color: "var(--muted-foreground)",
        "&:hover": {
          backgroundColor: "var(--accent)",
          color: "var(--accent-foreground)",
        },
      }}
    >
      {theme === "light" ? (
        <MoonIcon className="h-4 w-4" />
      ) : (
        <SunIcon className="h-4 w-4" />
      )}
    </IconButton>
  );
});
